import { getParentFolderId } from '../selectors/mailRowDataPropertyGetter';
import type TableView from '../store/schema/TableView';

/**
 * Returns the parent folder shared by all rows, or undefined when the rows do not have one
 * common parent folder.
 */
export function getCommonParentFolderId(
    rowKeys: readonly string[],
    tableView: TableView
): string | undefined {
    let commonParentFolderId: string | undefined;

    for (const rowKey of rowKeys) {
        const parentFolderId = getParentFolderId(rowKey, tableView);
        if (!parentFolderId) {
            return undefined;
        }

        if (commonParentFolderId === undefined) {
            commonParentFolderId = parentFolderId;
        } else if (commonParentFolderId !== parentFolderId) {
            return undefined;
        }
    }

    return commonParentFolderId;
}
